<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<acc-modal-float (closing)="onClose()"
                 [title]="title"
                 [showFooter]="false"
                 borderStyle="solid 2px darkgreen"
                 iconRef="/assets/icons/utility-sprite/svg/symbols.svg#edit">

  <acc-form (saveRecord)="onSaveRecord($event)"
            [initialTab]="initialTab"
            [record]="record"
            [showClose]="true"
            [ui]="ui"></acc-form>

</acc-modal-float>
